import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'name', label: t('Languages.table-col-1') },
    { id: 'countryCode', label: t('Languages.table-col-2') },
];
